import { isTypeLogoWithQuoteSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulLogo from './ContentfulLogo';
import Quote from './util/Quote';

const ContentfulLogoWithQuoteSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeLogoWithQuoteSection(entry)) {
    return null;
  }

  return (
    <div>
      <div className='flex flex-col sm:grid sm:auto-cols-auto sm:grid-flow-col items-center sm:items-start'>
        {entry.fields.logos?.map((logoWithQuote) => (
          <div className='flex-grow'>
            <ContentfulLogo entry={logoWithQuote?.fields.logo} />
            <div className='-mt-10'>
              {logoWithQuote?.fields.quote && <Quote text={logoWithQuote?.fields.quote} isSmall />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentfulLogoWithQuoteSection;
